// extracted by mini-css-extract-plugin
module.exports = {"bg":"FlavorSlide_bg__SAhWr","gradient":"FlavorSlide_gradient__43bwe","cans":"FlavorSlide_cans__WzRnT"};